import { Skeleton } from "antd";
import SectionCardSkeleton from "./SectionCardSkeleton";

const CustomerProfileSkeleton = () => (
    <SectionCardSkeleton>
        <div className="flex flex-col items-center">
            <Skeleton.Avatar active size={80} />
            <Skeleton active title={{ width: 160 }} paragraph={{ rows: 1, width: 120 }} className="!mt-4 !w-full" />
        </div>
        <div className="mt-5 space-y-3">
            <Skeleton active paragraph={{ rows: 1, width: "75%" }} />
            <Skeleton active paragraph={{ rows: 1, width: "90%" }} />
        </div>
        <Skeleton.Button active block className="!mt-5 !h-10 !rounded-full" />
    </SectionCardSkeleton>
);

export default CustomerProfileSkeleton;
